export default "__VITE_ASSET__DAM_6Qui__"